import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useGetRegisterInfoApi } from '@/api/conference';
import TablePagination from '@/components/common/Pagination/TablePagination';
import ArrowLeftIcon from '@/components/Icon/ArrowLeftIcon';
import { formatPayInfoRegisterListDate } from '@/utils/dateTime';
import { downloadPdf } from '@/utils/fileUtils';

import * as S from './style';

const SocietyConfirm = () => {
	const navigate = useNavigate();

	const [page, setPage] = useState(1);
	const { data: registerInfoData } = useGetRegisterInfoApi({
		page: page,
		row: 10,
		goods_type: '등록비',
	});

	const handleBackButton = () => {
		navigate(-1);
	};

	const isPendingPayment = (state?: string) => state === '결제대기';

	return (
		<S.Container noData={registerInfoData?.register_info?.length === 0}>
			<S.BackButton onClick={handleBackButton}>
				<ArrowLeftIcon iconColor="#01337D" width="16" height="16" />
				<span>이전 화면으로</span>
			</S.BackButton>
			{registerInfoData?.register_info?.length !== 0 ? (
				<TablePagination activePage={page} totalItems={registerInfoData?.total_count} onChange={(page) => setPage(page)}>
					<S.TableBox>
						{registerInfoData?.register_info?.map((item, index) => (
							<S.TableItem key={index}>
								<S.TableContent>
									<p className="info">
										{formatPayInfoRegisterListDate(item)} | {item.pay_info_pay_method}
										{isPendingPayment(item.pay_info_state) ? ' · 입금대기' : ''}
									</p>
									<p>{item.pay_info_goods_name}</p>
								</S.TableContent>
								<S.ButtonBox>
									{item.pay_info_pay_method !== '무통장입금' && !isPendingPayment(item.pay_info_state) && (
										<S.Button type="button" onClick={() => downloadPdf(item.pay_info_pk ?? '', 'receipt')}>
											영수증 확인
										</S.Button>
									)}
									{!isPendingPayment(item.pay_info_state) && (
										<S.Button type="button" onClick={() => downloadPdf(item.pay_info_pk ?? '', 'transaction')}>
											거래명세서 확인
										</S.Button>
									)}
								</S.ButtonBox>
							</S.TableItem>
						))}
					</S.TableBox>
				</TablePagination>
			) : (
				<S.NoData>등록 내역이 없습니다.</S.NoData>
			)}
		</S.Container>
	);
};

export default SocietyConfirm;
